var exports = {
  "nM": "row__qSrUeJ",
  "Kk": "icon__QFZOya",
  "Qq": "text__n2iVpD",
  "lN": "emphasis__8snuvW",
};

module.exports = exports;
